var _defs, _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTransact({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    baseProfile: "tiny-ps",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 31",
    width: 32,
    height: 31,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "transact-svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grd1",
    gradientUnits: "userSpaceOnUse",
    x1: 19.48,
    y1: 1.4,
    x2: 19.48,
    y2: 29.4
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5cbdaf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3a8ca8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "grd2",
    gradientUnits: "userSpaceOnUse",
    x1: 19.48,
    y1: 1.4,
    x2: 19.48,
    y2: 29.4
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5cbdaf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3a8ca8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "grd3",
    gradientUnits: "userSpaceOnUse",
    x1: 19.48,
    y1: 1.4,
    x2: 19.48,
    y2: 29.4
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5cbdaf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3a8ca8"
  })))), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\ttspan { white-space:pre }\n\t\t.shp0 { fill: url(#grd1) } \n\t\t.shp1 { fill: url(#grd2) } \n\t\t.shp2 { fill: url(#grd3) } \n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "shp0",
    d: "M11.32 15.93C10.63 16.63 10.63 17.77 11.32 18.47C12 19.18 13.12 19.18 13.8 18.47L19.08 13.07C19.77 12.37 19.77 11.23 19.08 10.53L13.8 5.13C13.12 4.42 12 4.42 11.32 5.13C10.63 5.83 10.63 6.97 11.32 7.67L13.59 10L7.28 10L7.28 4.6C7.28 2.61 8.86 1 10.8 1L19.6 1C21.54 1 23.12 2.61 23.12 4.6L23.12 19C23.12 20.99 21.54 22.6 19.6 22.6L10.8 22.6C8.86 22.6 7.28 20.99 7.28 19L7.28 13.6L13.59 13.6L11.32 15.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "shp1",
    d: "M3.76 13.6C2.79 13.6 2 12.79 2 11.8C2 10.81 2.79 10 3.76 10L7.28 10L7.28 13.6L3.76 13.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "shp2",
    d: "M14.32 26.2C14.32 28.19 15.9 29.8 17.84 29.8L26.64 29.8C28.58 29.8 30.16 28.19 30.16 26.2L30.16 11.8C30.16 9.81 28.58 8.2 26.64 8.2L26.64 26.2L14.32 26.2Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransact);
export default __webpack_public_path__ + "static/media/transact.b93ce345.svg";
export { ForwardRef as ReactComponent };